import React from "react";



export function Home() {
       return (
              <div className="container my-5">
                     <h2 className="text-center mb-3">Home Page</h2>
              </div>
       );
}